import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const customerService = {};

// List Customer
customerService.listCustomer = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "total_qty",
    "unworn_qty",
    "id",
    "name",
    "code",
    "note",
    // "phone_number",
    // "address",
    // "ward_code",
    // "district_code",
    // "province_code",
    "description",
    "maker_id",
    "maker_date",
    "maker.id",
    "maker.display_name",
    "checker_id",
    "checker_date",
    "checker.id",
    "checker.display_name",
    "record_status",
    "tenant_code",
    "source",
    "is_noted",
  ];

  return fetchV2({
    url: `${env.API_MSP}/customers`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create Customer
customerService.createCustomer = data => {
  return fetchV2({
    url: `${env.API_MSP}/customers`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// createCodeOfCustomer
customerService.createCodeOfCustomer = data => {
  return fetchV2({
    url: `${env.API_MSP}/customer-references`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// createCodeOfCustomer
customerService.getExportFileFromcreateCodeOfCustomer = data => {
  return fetchV2({
    url: `${env.API_MSP}/customer-references/status/${data?.batch_id}`,
    method: "get",
  });
};

// createCodeOfCustomer
customerService.downloadExportFileFromcreateCodeOfCustomer = data => {
  return fetchV2({
    url: `${env.API_MSP}/customer-references/download/${data?.batch_id}`,
    method: "get",
    responseType: "arraybuffer",
  });
};

// Detail Customer
customerService.detailCustomer = ({
  customerId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/customers/${customerId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update Customer
customerService.updateCustomer = ({ customerId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/customers/${customerId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete Customer
customerService.deleteCustomer = ({ customerId = undefined }) => {
  return fetchV2({
    url: `${env.API_MSP}/customers/${customerId}`,
    method: "delete",
  });
};

// Active Customer
customerService.activeCustomer = ({ customerId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/customers/${customerId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// List Customer by rule
customerService.listCustomerByKeySearch = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "maker_id",
    "checker_id",
    "checker_date",
    "tenant_code",
    "mod_no",
    "record_status",
    "auth_status",
    "name",
    "code",
    "phone",
    "mail",
    "note",
  ];

  return fetchV2({
    url: `${env.API_MSP}/customers/search`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      shipping_type: params.shipping_type || null,
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// List CustomerSchedules
customerService.listCustomerSchedules = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/customer-schedules`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

customerService.createCustomerSchedules = ({
  id_customer = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-schedules`,
    method: "post",
    data: {
      id_customer,
      ...data,
    },
  });
};

customerService.updateCustomerSchedules = ({
  id_schedules = undefined,
  id_customer = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-schedules/${id_schedules}`,
    method: "put",
    data: {
      id_customer,
      ...data,
    },
  });
};

customerService.deleteCustomerSchedules = ({ id_schedules }) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-schedules/${id_schedules}`,
    method: "delete",
  });
};

// List Customer
customerService.listCustomerLocationTransport = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/customer-location-transports`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// List Customer
customerService.createCustomerLocationTransport = data => {
  return fetchV2({
    url: `${env.API_MSP}/customer-location-transports`,
    method: "post",
    data,
  });
};

// List Customer
customerService.updateCustomerLocationTransport = ({
  id = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-location-transports/${id}`,
    method: "put",
    data,
  });
};

customerService.deleteCustomerLocationTransport = ({ id }) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-location-transports/${id}`,
    method: "delete",
  });
};

// List Customer
customerService.listSaleOfCustomer = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/customer-sales`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      searchContent: params.searchContent || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// listCodeOfCustomer
customerService.listCodeOfCustomer = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/customer-references`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

customerService.exportCodeUse = ({ params, excelParams }) => {
  const columnFilter = params.columnFilter || {};
  return fetchV2({
    url: `${env.API_MSP}/customer-references/export`,
    method: "get",
    timeout: 60000,
    params: {
      ...columnFilter,
      keywords: params.keywords || "",
      "filter[record_status]": "O",
      ...excelParams,
      sort: "-maker_date",
    },
    responseType: "arraybuffer",
  });
};
customerService.getCustomerSales = ({ customerId, params = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/customers/${customerId}/sale`,
    method: "get",
    params: {
      page: -1,
      ...params,
    },
  });
};

export default customerService;
